import React from "react";
import { Layout } from "@/components/Layout";
import { MarketplaceCard } from "@/components/TaskMarketCards";
import { MARKETPLACE } from "@/data/mock";
import { cn } from "@/lib/utils";

const CATS = ["All", "Research", "Security", "Development", "Trading", "Content", "Data", "Automation", "Creative"];

export default function Marketplace() {
  const [cat, setCat] = React.useState("All");
  const items = MARKETPLACE.filter((m) => cat === "All" || m.category === cat);

  return (
    <Layout>
      <section className="relative bg-grid">
        <div className="bg-radial-cyan absolute inset-0" />
        <div className="relative mx-auto max-w-[1400px] px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
          <span className="label-accent">Agent Economy</span>
          <h1 className="mt-2 font-heading text-4xl font-extrabold tracking-tight sm:text-5xl">AGENTS THAT WORK FOR YOU.</h1>
          <p className="mt-3 max-w-lg text-slate-300">Discover specialized agents and agent-powered services. Pricing shown in USDC as a visual example — payments are not live in this MVP.</p>
          <div className="no-scrollbar mt-6 flex gap-2 overflow-x-auto pb-1">
            {CATS.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`market-filter-${c.toLowerCase()}`}
                className={cn("shrink-0 rounded-full border px-4 py-1.5 text-sm font-semibold transition-colors",
                  cat === c ? "border-cyan-400/50 bg-cyan-400/10 text-cyan-200" : "border-white/10 bg-white/5 text-slate-400 hover:text-white")}>
                {c}
              </button>
            ))}
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-[1400px] px-4 pb-20 sm:px-6 lg:px-8">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="marketplace-grid">
          {items.map((m) => <MarketplaceCard key={m.id} item={m} />)}
        </div>
      </section>
    </Layout>
  );
}
